var mySwiper = new Swiper("#product-description-slide01", {
		loop: true,
		navigation: {
			nextEl: ".swiper-button-next#btn-next01",
			prevEl: ".swiper-button-prev#btn-prev01"
		},
		pagination: {
			el: ".swiper-pagination#pagi01",
			clickable: true
		}
	}),
	mySwiper = new Swiper("#product-description-slide02", {
		loop: true,
		navigation: {
			nextEl: ".swiper-button-next#btn-next02",
			prevEl: ".swiper-button-prev#btn-prev02"
		},
		pagination: {
			el: ".swiper-pagination#pagi02",
			clickable: true
		}
	}),
	mySwiper = new Swiper("#product-description-slide03", {
		loop: true,
		navigation: {
			nextEl: ".swiper-button-next#btn-next03",
			prevEl: ".swiper-button-prev#btn-prev03"
		},
		pagination: {
			el: ".swiper-pagination#pagi03",
			clickable: true
		}
	}),
	mySwiper = new Swiper("#product-description-slide04", {
		loop: true,
		navigation: {
			nextEl: ".swiper-button-next#btn-next04",
			prevEl: ".swiper-button-prev#btn-prev04"
		},
		pagination: {
			el: ".swiper-pagination#pagi04",
			clickable: true
		}
	}),
	mySwiper = new Swiper("#product-description-slide05", {
		loop: true,
		navigation: {
			nextEl: ".swiper-button-next#btn-next05",
			prevEl: ".swiper-button-prev#btn-prev05"
		},
		pagination: {
			el: ".swiper-pagination#pagi05",
			clickable: true
		}
	}),
	mySwiper = new Swiper("#product-description-slide-gall", {
		loop: true,
		navigation: {
			nextEl: ".swiper-button-next#btn-next-gall",
			prevEl: ".swiper-button-prev#btn-prev-gall"
		},
		pagination: {
			el: ".swiper-pagination#pagi-gall",
			clickable: true
		}
	});
